var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgMeasure = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28.583,
    height: 28.583,
    viewBox: "0 0 28 28",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ruler",
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2757",
    "data-name": "Group 2757",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2756",
    "data-name": "Group 2756"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3011",
    "data-name": "Path 3011",
    d: "M28.4,7.5,21.087.179a.61.61,0,0,0-.863,0L.179,20.224a.61.61,0,0,0,0,.863L7.5,28.4a.61.61,0,0,0,.863,0L28.4,8.359A.61.61,0,0,0,28.4,7.5ZM7.924,27.106,1.477,20.659,6.32,15.816l2.2,2.2a.61.61,0,1,0,.876-.851l-.012-.012-2.2-2.192,1.6-1.6,3.429,3.429a.613.613,0,0,0,.863-.869L9.644,12.491l1.6-1.6,2.2,2.192a.61.61,0,1,0,.863-.863l-2.2-2.192,1.6-1.6,3.429,3.429A.61.61,0,1,0,18,11L14.567,7.569l1.6-1.6,2.2,2.2a.61.61,0,1,0,.869-.857l-.006-.006-2.18-2.216,1.6-1.6L22.073,6.92a.61.61,0,1,0,.863-.863L19.508,2.628l1.151-1.151,6.447,6.447Z",
    transform: "translate(0 0)",
    fill: "#1c2d41"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2759",
    "data-name": "Group 2759",
    transform: "translate(5.054 19.711)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2758",
    "data-name": "Group 2758"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3012",
    "data-name": "Path 3012",
    d: "M85.9,322.524a1.966,1.966,0,1,0,0,2.78A1.97,1.97,0,0,0,85.9,322.524Zm-.8,1.9a.07.07,0,0,1-.067.025.745.745,0,1,1,0-1.053A.723.723,0,0,1,85.1,324.422Z",
    transform: "translate(-82.55 -321.95)",
    fill: "#1c2d41"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMeasure, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/measure.f9b1742b.svg";
export { ForwardRef as ReactComponent };